import classNames from 'classnames';
import Div100vh from 'react-div-100vh';
import React from 'react';
import ReactDOM from 'react-dom';
import './Overlay.scss';

interface OverlayProps {
  content?: any;
  children?: any;
  showOverlay?: any;
  centre?: any;
  transparent?: any;
}

const Overlay = ({
  content,
  children,
  showOverlay,
  centre,
  transparent,
}: OverlayProps) =>
  showOverlay
    ? ReactDOM.createPortal(
        <Div100vh
          className={classNames('overlay', {
            'overlay--visible': showOverlay,
            'overlay--centre': centre,
            'overlay--transparent': transparent,
          })}
        >
          {children ?? content}
        </Div100vh>,
        document.body
      )
    : null;
export default Overlay;
